import {
  login
} from '@/api/user/login' //引入登录 api 接口
import {
  selectAllUser
} from '@/api/user/selectAllUser' //引入登录 api 接口

import {
  insertUser
} from '@/api/user/selectAllUser' //引入添加 api 接口
import {
  updateuser
} from '@/api/user/selectAllUser' //引入添加 api 接口
import {
  deleteuser
} from '@/api/user/selectAllUser' //引入添加 api 接口


const apiInterfaceUser = {
  actions: {
    // 验证登录
    Login({
      commit
    }, user) { //定义 Login 方法，在组件中使用 this.$store.dispatch("Login") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        login(user.username, user.password).then(response => { //使用 login 接口进行网络请求
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
    //查询所有用户信息
    getAllUserList({
      commit
    }, ) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        selectAllUser().then(response => { //使用 login 接口进行网络请求
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
    //添加用户
    AddUser({
      commit
    }, user) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        insertUser(user).then(response => { //使用 login 接口进行网络请求
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
    //修改用户
    UpdateUser({
      commit
    }, user) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateuser(user).then(response => { //使用 login 接口进行网络请求
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
    //删除用户
    Deleteuserinfo({
      commit
    }, jo) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        deleteuser(jo).then(response => { //使用 login 接口进行网络请求
          commit('') //提交一个 mutation，通知状态改变   
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
  }

}
export default apiInterfaceUser